import UserStore from 'stores/root/UserStore';

import ClsDataStore from 'stores/shared/ClsDataStore';

import PageStore from './PageStore';
import { RootStoreT } from 'types/frontend/RootStore';
import NavigationStore from './NavigationStore';
import StudentListDataStore from 'stores/shared/StudentListDataStore';
import AlertStore from './AlertStore';
import { reaction } from 'mobx';
import TeacherListDataStore from 'stores/TeacherListDataStore';
import NavbarSearchStore from './NavbarSearchStore';
import ClsWrapperStore from 'stores/shared/ClsWrapperStore';
import ChangeEventStore from './ChangeEventStore';

export const updateVersion = (version: 'studentList' | 'teacherList' | 'clsList' | 'myInfo') => {
  console.log('updateVersion', version);
  switch (version) {
    case 'studentList':
      rootStore.studentListDataStore.setVersion(new Date().toString());
      break;
    case 'teacherList':
      rootStore.teacherListDataStore.setVersion(new Date().toString());
      break;

    case 'clsList':
      rootStore.clsDataStore.setVersion(new Date().toString());
      break;
    case 'myInfo':
      rootStore.userStore.setVersion(new Date().toString());
  }
};

export const getActiveAcademyId = () => {
  return rootStore.pageStore.activeAcademyId;
};

export const getActiveAcademySetting = () => {
  return rootStore.userStore.activeAcademySetting;
};

const userStore = new UserStore();
const clsDataStore = new ClsDataStore();
const clsWrapperStore = new ClsWrapperStore(clsDataStore, false, userStore);
const teacherListDataStore = new TeacherListDataStore(clsDataStore);
const studentListDataStore = new StudentListDataStore(clsDataStore);
const pageStore = new PageStore();
const navigationStore = new NavigationStore();
const changeEventStore = new ChangeEventStore();
const alertStore = new AlertStore();
const navbarSearchStore = new NavbarSearchStore(
  studentListDataStore,
  teacherListDataStore,
  clsDataStore,
  userStore,
);

const rootStore: RootStoreT = {
  userStore,
  clsDataStore,
  clsWrapperStore,
  teacherListDataStore,
  studentListDataStore,
  pageStore,
  navigationStore,
  changeEventStore,
  alertStore,
  navbarSearchStore,

  stores: {},
};

// clsDataStore와 studentListDataStore는
// 로그인한 상태에서만 불러온다.
console.log('rootStore reaction');
console.log('userStore.myInfo', userStore.myInfoTimestamp);
reaction(
  () => userStore.myInfoTimestamp,
  () => {
    console.log('userStore.myInfo reaction');
    if (userStore.myInfo) {
      console.log('userStore.myInfo reaction valid');
      rootStore.clsDataStore.init('rootStore');
      rootStore.clsWrapperStore.init();
      rootStore.studentListDataStore.refresh();
    }
  },
);

export { rootStore };

// app 에서는 clsDataStore와 studentListDataStore는 항상 init한다.
